import { gql } from 'graphql-request';

export const riskInsightsAvailableDatesQuery = gql`
    query RiskInsightsAvailableDates($businessCentralId: String!) {
        organisation(businessCentralId: $businessCentralId) {
            riskInsightsAvailableDates
        }
    }
`;

export type RiskInsightsAvailableDatesResult = {
    organisation: {
        riskInsightsAvailableDates: string[];
    };
};
